/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Staatsexamen_Jura27Inputs */

const en__field_enum_csjensblank_staatsexamen_jura27 = /** @type {(inputs: _Field_Enum_Csjensblank_Staatsexamen_Jura27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staatsexamen Jura`)
};

const de__field_enum_csjensblank_staatsexamen_jura27 = /** @type {(inputs: _Field_Enum_Csjensblank_Staatsexamen_Jura27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staatsexamen Jura`)
};

/**
* | output |
* | --- |
* | "Staatsexamen Jura" |
*
* @param {_Field_Enum_Csjensblank_Staatsexamen_Jura27Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_staatsexamen_jura27 = /** @type {((inputs?: _Field_Enum_Csjensblank_Staatsexamen_Jura27Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Staatsexamen_Jura27Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_staatsexamen_jura27(inputs)
	return de__field_enum_csjensblank_staatsexamen_jura27(inputs)
});
export { _field_enum_csjensblank_staatsexamen_jura27 as "_field_enum_CSJENSBLANK_STAATSEXAMEN_JURA" }